import { render } from "./alert_Uikit.vue?vue&type=template&id=058c6712"
import script from "./alert_Uikit.vue?vue&type=script&lang=js"
export * from "./alert_Uikit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__